const catalogRails = document.querySelectorAll('[data-daaman-catalog-autoplay]');
const mobileQuery = window.matchMedia('(max-width: 749px)');
const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

catalogRails.forEach((rail) => {
  let frame = 0;
  let lastTime = 0;
  let direction = 1;
  let pauseUntil = performance.now() + 900;
  const speed = Number.parseFloat(rail.dataset.daamanCatalogSpeed || '10');

  const pause = (duration = 3600) => {
    pauseUntil = performance.now() + duration;
  };

  const stop = () => {
    if (frame) {
      window.cancelAnimationFrame(frame);
      frame = 0;
    }
  };

  const tick = (time) => {
    if (!mobileQuery.matches || reduceMotionQuery.matches || rail.scrollWidth <= rail.clientWidth + 8) {
      stop();
      return;
    }

    if (!lastTime) lastTime = time;
    const delta = Math.min(time - lastTime, 64) / 1000;
    lastTime = time;

    if (time >= pauseUntil) {
      const maxScroll = rail.scrollWidth - rail.clientWidth;
      const nextScroll = rail.scrollLeft + speed * delta * direction;

      if (nextScroll >= maxScroll) {
        rail.scrollLeft = maxScroll;
        direction = -1;
        pause(1100);
      } else if (nextScroll <= 0) {
        rail.scrollLeft = 0;
        direction = 1;
        pause(1100);
      } else {
        rail.scrollLeft = nextScroll;
      }
    }

    frame = window.requestAnimationFrame(tick);
  };

  const start = () => {
    if (frame || !mobileQuery.matches || reduceMotionQuery.matches) return;
    lastTime = 0;
    frame = window.requestAnimationFrame(tick);
  };

  rail.addEventListener('pointerdown', () => pause(4800), { passive: true });
  rail.addEventListener('touchstart', () => pause(4800), { passive: true });
  rail.addEventListener('wheel', () => pause(3600), { passive: true });
  rail.addEventListener('focusin', () => pause(4800));
  rail.addEventListener('mouseenter', () => pause(2400));
  window.addEventListener('resize', () => {
    stop();
    start();
  }, { passive: true });

  mobileQuery.addEventListener?.('change', () => {
    stop();
    start();
  });
  reduceMotionQuery.addEventListener?.('change', () => {
    stop();
    start();
  });

  start();
});
